import { routeStoreLenses } from 'root/src/client/logic/route/lenses'

const { pathOrQuery } = routeStoreLenses

export default pathOrQuery({})
